module.exports = __webpack_public_path__ + "static/media/mobile-android.d238bbc9.svg";